import React from "react"
import { useSiteContext } from "../common/SiteContext";
import { ExpandingImageWithContentBlade } from "@organic-return/foundation-react/src/components/Blades/ExpandingImageWithContentBlade"
import { Button } from "@organic-return/foundation-react/src/components/Button/Button";
import { FaMapMarkerAlt } from "react-icons/fa";

export const ContactDetailsSection = ({ module }) => {
    const siteContext = useSiteContext();
    const fields = module.customFields;

    const addressLines: any = [];
    fields.addressLine1 && addressLines.push(fields.addressLine1);
    fields.addressLine2 && addressLines.push(fields.addressLine2);
    fields.addressLine3 && addressLines.push(fields.addressLine3);

    const childComponent = (
        <div className="w-full">
            {fields.tilte && (
                <h2 className="mb-8 xl:mb-12 py-0 text-5xl">{fields.tilte}</h2>
            )}
            {(fields.underTitleCTA?.href || fields.underTitleCTA?.text) && (
                <Button linkProps={{
                    className: "mb-8 xl:mb-12",
                    href: fields.underTitleCTA?.href ?? ""
                }}>
                    {fields.underTitleCTA?.text}
                </Button>
            )}
            {fields.description && (
                <p className="mb-8 xl:mb-12">
                    {fields.description}
                </p>
            )}
            <div className="mb-8 xl:mb-12 leading-8">
                {addressLines.length > 0 && (
                    <address className="text-3xl not-italic mb-2.5 font-bold">
                        {addressLines.map((line, index) => (
                            <>
                                {index == 0 && (<FaMapMarkerAlt className="hidden lg:inline text-xl text-accent mr-5" />)}{line}{index < addressLines.length - 1 && (<br />)}
                            </>
                        ))}
                    </address>
                )}
                <span>
                    {fields.phoneNumberLabel1 && (<><b>{fields.phoneNumberLabel1}:</b>&nbsp;</>)}
                    {fields.phoneNumberValue1 && (<><a href={`tel:${fields.phoneNumberValue1}`}>{fields.phoneNumberValue1}</a><br /></>)}
                </span>
                <span>
                    {fields.phoneNumberLabel2 && (<><b>{fields.phoneNumberLabel2}:</b>&nbsp;</>)}
                    {fields.phoneNumberValue2 && (<><a href={`tel:${fields.phoneNumberValue2}`}>{fields.phoneNumberValue2}</a><br /></>)}
                </span>
                <span>
                    {fields.email && (<><b>email:</b>&nbsp;<a href={`mailto:${fields.email}`}>{fields.email}</a><br /></>)}
                </span>
            </div>
            {(fields.bottomCTA?.href || fields.bottomCTA?.text) && (
                <Button linkProps={{
                    href: fields.bottomCTA?.href ?? ""
                }}>
                    {fields.bottomCTA?.text}
                </Button>
            )}
        </div>
    )

    return (
        <ExpandingImageWithContentBlade
            imageUrl={fields.image?.url}
            children={childComponent}
        />
    )

}

export default ContactDetailsSection